import React, { useContext, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Store } from '../data/Store';
import { templateSearch } from '../data/Actions';

import Autocomplete from 'react-autocomplete';

import styled from 'styled-components';

const AutoWrapper = styled.div`
    display: grid;
    grid-template: 1fr / auto 1fr;
    width: 100%;
    input {
        width: 100%;
    }
    span {
        padding: 0 10px;
    }
`;

function InputLink(props, ref) {
    const [inputRef, setInputRef] = useState(null);
    const [inputType, setInputType] = useState(props.type || 'text');
    // const inputRef = React.createRef();
    const autoRef = useRef(inputRef);
    useImperativeHandle(ref, () => ({
        focus: () => {
          autoRef.current.focus();
        }
    }));
    
    const { state, dispatch } = useContext(Store);
    
    function buildSearch(name, value) {
        let ItemId = state.Template.ItemId.value;
        let LotId = state.Template.LotId.value;
        let searchData = [];
        
        if (name === 'Template.ItemId') {
            ItemId = value;
        }    
        if (name === 'Template.LotId') {
            LotId = value;
        }
        
        if (ItemId !== '') searchData.push({key:'Pedigree.Transaction.ItemId', value: ItemId});
        if (LotId !== '') searchData.push({key:'Pedigree.Transaction.LotId', value: LotId});
          
        const path = {LotId, ItemId};
        const data = {
            path: path,
            search: searchData,
            limit: 10,
            next: ''
        };
        templateSearch(data, state, dispatch );
    }

    function onChange(e){
        buildSearch(e.target.name, e.target.value);
    }

    function onSelect(val){
        buildSearch(props.name, val);
    }

    function renderItem(item, isHighlighted){
        return (
            <div style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '2px 10px', borderLeft: '1px solid rgb(199 197 197)', borderRight: '1px solid rgb(199 197 197)'}}>
                {item}
            </div>   
        ); 
    }

    function getItemValue(item){
        return `${item}`;
    }
    
    function buildPath(keys, key, obj) {
        keys = `${keys}.${key}`;

        return keys.split('.').reduce((o,i)=>{
            return (Array.isArray(o)) ? o[parseInt(i)] : o[i];
        }, obj);
    }

  return (
    <AutoWrapper>
            <span>{props.label}</span>
            <Autocomplete
                wrapperStyle={{ position: 'relative'}}
                menuStyle={{ position: 'absolute', top: 'calc(100% - 4px)', left: '0', zIndex: '2'}}
                ref={el => setInputRef(el)}
                getItemValue={getItemValue}
                items={buildPath(props.name, 'auto', state)}
                renderItem={renderItem}
                value={buildPath(props.name, 'value', state)}
                onChange={onChange}
                onSelect={onSelect}
                inputProps={{name: props.name,
                            type: inputType,
                            placeholder: buildPath(props.name, 'auto', state)[0],
                            
                }}
            ></Autocomplete>
        </AutoWrapper>
  );
}
export default forwardRef(InputLink); 